import * as Yup from 'yup';
import Translator from '../../../../services/translate-factory';

const T = Translator.create();

export const SolutionActivityAddFormVal = Yup.object().shape({
  activity_no: Yup.string().required(T.t('gen_cannot_leave_empty')),
  start_hour: Yup.string().required(T.t('gen_cannot_leave_empty')),
  week_of_day: Yup.string().required(T.t('gen_cannot_leave_empty')),
});
